import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function HealthcareNetwork(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#00BDBD" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path
        d="M14.7862 9.26749H17.722C18.5382 9.26749 19.1998 9.92911 19.1998 10.7452V13.2972C19.1998 14.1133 18.5382 14.7749 17.722 14.7749H16.9497C15.7255 14.7749 14.733 15.7674 14.733 16.9916V17.7222C14.733 18.5384 14.0714 19.2 13.2553 19.2H10.6912C9.87501 19.2 9.2134 18.5384 9.2134 17.7222V17.2506C9.2134 16.4577 9.8562 15.8149 10.6491 15.8149C12.0317 15.8149 13.3292 15.2737 14.3076 14.2974C15.1478 13.4591 15.6689 12.3661 15.7966 11.1882C15.8072 11.1457 15.8072 11.1139 15.8072 11.0715C15.8072 10.7743 15.5626 10.5303 15.2648 10.5303C14.967 10.5303 14.7224 10.7743 14.7224 11.0715C14.6161 12.0053 14.2013 12.8754 13.5419 13.5334C12.7762 14.308 11.7446 14.7325 10.6491 14.7325H9.22403H6.27756C5.46142 14.7325 4.7998 14.0709 4.7998 13.2547V10.724C4.7998 9.90788 5.46142 9.24627 6.27756 9.24627H7.04993C8.27415 9.24627 9.26657 8.25384 9.26657 7.02963V6.27775C9.26657 5.4616 9.92819 4.79999 10.7443 4.79999H13.3191C14.1352 4.79999 14.7969 5.4616 14.7969 6.27774V6.75999C14.7969 7.54706 14.1588 8.1851 13.3717 8.1851C11.9892 8.1851 10.6917 8.72629 9.71325 9.70257C8.87307 10.5409 8.35195 11.6339 8.22432 12.8118C8.21369 12.8542 8.21369 12.8861 8.21369 12.9285C8.21369 13.2256 8.4583 13.4697 8.75608 13.4697C9.05387 13.4697 9.29848 13.2256 9.29848 12.9285C9.40483 11.9947 9.8196 11.1245 10.479 10.4666C11.2447 9.69196 12.2763 9.26749 13.3717 9.26749H14.7862Z"
        fill="white"
      />
    </svg>
  );
}

HealthcareNetwork.propTypes = propTypes;
HealthcareNetwork.defaultProps = defaultProps;

export default HealthcareNetwork;
